var exports = {
  "wk": "AuthBrandPanel.module__brand___VWRzb3",
  "D_": "AuthBrandPanel.module__identity___VWRzb3",
  "wm": "AuthBrandPanel.module__logo___VWRzb3",
  "Y4": "AuthBrandPanel.module__textTier___VWRzb3",
  "Nr": "AuthBrandPanel.module__card___VWRzb3",
  "Ss": "AuthBrandPanel.module__wordmark___VWRzb3",
  "Hc": "AuthBrandPanel.module__host___VWRzb3",
  "Hw": "AuthBrandPanel.module__mobile___VWRzb3",
  "lD": "AuthBrandPanel.module__split___VWRzb3",
};

module.exports = exports;
